<div class="container-fuild">
    <div class="p-grid pt-2">
        <div class="p-col-7 align-middle">
            <h5 class="mb-0">Add Task / Petition Details</h5>
        </div>
        <div class="p-col-5 text-right align-middle">
            <i (click)="handleClose()" class="close-icon pi pi-times"></i>
        </div>
    </div>
    <hr class="mt-0 mb-1" />
    <div class="p-col-12 p-0" *ngIf="!isVDTask">
        <form [formGroup]="taskAdditionalDetailsForm">
            <div class="w-100 main-body">
                <div [ngSwitch]="taskAdditionalDetailsForm.get('taskTypeCode').value">
                  <div *ngSwitchCase="'RFE'" class="px-0">
                    <div class="p-grid dashed-line p-my-4"></div>
                    <app-rfe-task [parentFormGroup]="taskAdditionalDetailsForm"></app-rfe-task>
                    <!-- <p>RRR- 1</p> -->
                    <app-add-interpreter *ngIf="task.isOutsideImagility === 0" [subTaskDetails]="task"></app-add-interpreter>
                  </div>
                  <div *ngSwitchCase="'PETITION'" class="px-0">
                    <app-petition-task [parentFormGroup]="taskAdditionalDetailsForm" [subTaskDetails]="task"></app-petition-task>
                    <!-- <p>RRR- 2</p> -->
                    <app-add-interpreter *ngIf="task.isOutsideImagility === 0" [subTaskDetails]="task"></app-add-interpreter>
                  </div>
                  <div *ngSwitchCase="'PERM'" class="px-0">
                    <app-perm-task [parentFormGroup]="taskAdditionalDetailsForm" [subTaskDetails]="task"></app-perm-task>
                    <!-- <p>RRR- 3</p> -->
                    <app-add-interpreter *ngIf="task.isOutsideImagility === 0" [subTaskDetails]="task"></app-add-interpreter>
                  </div>
                  <div *ngSwitchCase="'RECEFF'" class="px-0">
                    <app-perm-task [parentFormGroup]="taskAdditionalDetailsForm" [reSuperTask]="reSuperTask"></app-perm-task>
                  </div>
                  <div *ngSwitchCase="'PWD'" class="px-0">
                    <app-perm-task [parentFormGroup]="taskAdditionalDetailsForm"></app-perm-task>
                  </div>
                  <div *ngSwitchCase="'PERMSET'" class="px-3">
                    <app-perm-task [parentFormGroup]="taskAdditionalDetailsForm"></app-perm-task>
                  </div>
                  <div *ngSwitchCase="'I140'" class="px-0">
                    <app-i140-task [parentFormGroup]="taskAdditionalDetailsForm" [subTaskDetails]="task"></app-i140-task>
                    <!-- <p>RRR- 4, {{isImmigrant}}</p> -->
                    <app-add-interpreter *ngIf="task.isOutsideImagility === 0" [subTaskDetails]="task"></app-add-interpreter>
                  </div>
                  <div *ngSwitchCase="'I130'" class="px-0">
                    <app-i130 [parentFormGroup]="taskAdditionalDetailsForm" [beneficiaryList]="beneficiaryList" [subTaskDetails]="task"></app-i130>
                    <!-- <p>RRR- 5</p> -->
                    <app-add-interpreter *ngIf="task.isOutsideImagility === 0" [subTaskDetails]="task"></app-add-interpreter>
                  </div>
                </div>
            </div>
            <hr class="separator" />
            <div class="text-left">
              <button pButton type="button" class="mr-2" label="SAVE" title="SAVE"
                (click)="saveAdditionalDetails()" [disabled]="!taskAdditionalDetailsForm.valid"></button>
              <button pButton type="button" label="CANCEL" title="CANCEL" (click)="handleClose()"
                class="p-button-secondary"></button>
            </div>
        </form>
    </div>
    <div class="p-col-12 p-0" *ngIf="isVDTask">
        <form [formGroup]="newTaskFromTemplateForm">
            <div class="w-100  main-body">
                <ng-container *ngFor="let _data of taskJson; let i = index;">
                    <div *ngIf="_data.controlType == 'CUSTOM'"
                    [ngStyle]="{'margin-left': (_data.layoutCode ==='VdSwitchGroupComponent' || _data.layoutCode ==='CustomQuestionsGroupComponent') ? '44px' : '0px'}">
                      <ng-container *ngIf="_data.layoutCode !== 'SubTaskInterpreterDetailsComponent' || task.isOutsideImagility === 0">
                        <app-component-loader [rendercomponent]="_data.layoutCode" [sublabel]="_data.subText"
                          [validation]="_data.mandatory" [readonly]="_data.readonly" [minLength]="_data.minLength"
                          [maxLength]="_data.maxLength" [placeHolders]="_data.placeholder"
                          [groupElementProperty]="_data.groupElementProperty"
                          [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
                          [groupName]="_data.layoutCode ==='VdSwitchGroupComponent'  ? _data.name : null"
                          [inputParams]="_data" [group]="jsonInput" [formControlName]="_data.layoutCode+'_'+_data.name">
                      </app-component-loader>
                      </ng-container>
                    </div>
                    <div *ngIf="_data.controlType == 'STANDARD'">
                      <ng-container *ngIf="_data.layoutCode !== 'SubTaskInterpreterDetailsComponent' || task.isOutsideImagility === 0">
                        <app-component-loader [rendercomponent]="_data.layoutCode" [sublabel]="_data.subText"
                        [validation]="_data.mandatory" [readonly]="_data.readonly" [minLength]="_data.minLength"
                        [maxLength]="_data.maxLength" [placeHolders]="_data.placeholder"
                        [groupElementProperty]="_data.groupElementProperty"
                        [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
                        [groupName]="_data.layoutCode ==='VdSwitchGroupComponent'  ? 'switchGroup' : null"
                        [inputParams]="_data" [group]="newTaskFromTemplateForm"
                        [fieldConfiguration]="_data.fieldConfiguration" [i485SuperTask]="i485SuperTask"
                        [ds160SuperTask]="ds160SuperTask"
                        [templateTaskTypeId]="visaTemplateJson?.taskTypeId" [subTaskDetails]="task"></app-component-loader>
                      </ng-container>
                    </div>
                </ng-container>
            </div>
            <hr class="separator" />
            <div class="text-left">
                <button pButton type="button" class="mr-2" label="SAVE" title="SAVE"
                    (click)="saveAdditionalDetails()" [disabled]="!newTaskFromTemplateForm.valid"></button>
                    <!-- <button pButton type="button" class="mr-2" label="SAVE" title="SAVE"
                    (click)="saveAdditionalDetails()"></button> -->
                <button pButton type="button" label="CANCEL" title="CANCEL" (click)="handleClose()"
                    class="p-button-secondary"></button>
            </div>
        </form>
    </div>
</div>
